import { useTranslation } from 'react-i18next';

import { ReactComponent as CheckIcon } from '../../../../../../assets/icons/check-circle.svg';
import { ReactComponent as WarningIcon } from '../../../../../../assets/icons/warning.svg';
import {
  CENSUS_BACKGROUND_ISSUES_STATUS,
  CENSUS_BACKGROUND_STATUS_BY_STEP
} from '../../../../../constants/activationCensus';
import type { ActivationCensusStep } from '../../../../../hooks/useActivationCensusFlow/activationCensus';
import CustomButton from '../../../../Buttons/CustomButton/CustomButton';
import Spinner from '../../../../Globals/Spinner/Spinner';

import './CensusBackgroundStatus.scss';

export interface ICensusBackgroundStatusProps {
  step: ActivationCensusStep;
  onOpen: () => void;
}

const CensusBackgroundStatus = ({ step, onOpen }: ICensusBackgroundStatusProps) => {
  const { t } = useTranslation();
  const { tone, title, body, cta } = CENSUS_BACKGROUND_STATUS_BY_STEP[step] ?? CENSUS_BACKGROUND_ISSUES_STATUS;

  const icon = (() => {
    if (tone === 'info') return <Spinner size={16} variant="svg" aria-label={t(title)} />;
    if (tone === 'success') return <CheckIcon width={16} height={16} />;
    return <WarningIcon width={16} height={16} />;
  })();

  return (
    <div className={`census-bg-status census-bg-status--${tone}`}>
      <span className="census-bg-status__icon" aria-hidden={tone !== 'info'}>
        {icon}
      </span>
      <div className="census-bg-status__content">
        <div className="census-bg-status__title">{t(title)}</div>
        <p className="census-bg-status__body">{t(body)}</p>
      </div>
      <CustomButton variant="default" size="xs" onClick={onOpen}>
        {t(cta)}
      </CustomButton>
    </div>
  );
};

export default CensusBackgroundStatus;
